<sm-title-bar pageTitle="{{ 'employee_recharge.title' | translate }}" [back]="true" >
    <ng-template #addButton>
        <div class="d-flex search-field" >
          <button mat-flat-button color="accent" >
            {{ 'employee_recharge.btn_text' | translate }}
            <mat-icon class="material-icons-round" [inline]="true"
              >autorenew</mat-icon
            >
          </button>
         
        </div>
      </ng-template> </sm-title-bar>
<!-- <mat-card >
    <mat-card-header class="justify-content-between align-items-center mb-3">
      
       </mat-card-header>
    <div class="rounded-3 bg-light" *ngIf="!loader">
      <sm-data-table [columnHeaders]="tableDisplayColumns" [dataSource]="currentPlan" 
         >
      </sm-data-table>
    </div>
  </mat-card> -->
  <div class="merchant_detail_sec" >
    <div class="mrt_offe">
      <div class="row">
          <!-- <div class="col-sm-1"></div> -->
        <div class="col-sm-12">
          <div class="drt_head">
            <!-- the upar wala div will come here -->
          </div>
          <div class="list_user" *ngIf="loader == false">
            <a href="javascript:void(0)" class="admin_category">
              <div class="card_header chead">
                <div class="adm_set" *ngIf="currentPlan.length>0">
                  <div>
                    <span class="name_cont">{{currentPlan[0].planName}}</span>
                  
                    <!-- <button
                      mat-icon-button
                      class="profile_button"
                      class="share"
                    >
  
                    </button> -->
  
                    <!-- <mat-slide-toggle class="share" (change)="onToggleChange($event)" [checked]="toShowCheck === 1"></mat-slide-toggle> -->
                    <mat-icon class="material-icons-round share" style="font-size: 60px !important; color: #23db23;" [inline]="true"
                    >check_circle</mat-icon>
                    <h2 style="margin-top: 20px;" ><span style="    color: #898989;">{{ 'employee_recharge.valid_from' | translate }}: </span>{{currentPlan[0].fromDate | date}}</h2>
                    <h2 style="margin-top: 20px; " ><span style="    color: #898989;">{{ 'employee_recharge.valid_to' | translate }}: </span>{{currentPlan[0].toDate | date}}</h2>
                    <h2 style="margin-top: 20px;" ><span style="    color: #898989;">{{ 'employee_recharge.status' | translate }}:</span> {{currentPlan[0].status}}</h2>
                    <!-- <h4>Setup GST, Service tax or any other local tax here, if you are adding tax in your invoice, enable that from here. Also if you aren't, then make it disable.</h4> -->
                    <!-- <span class="material-icons share"> more_vert </span> -->
                  </div>
  
                  <!-- <img src="https://pbs.twimg.com/profile_images/1455185376876826625/s1AjSxph_400x400.jpg"> -->
                </div>
                <div class="adm_set" *ngIf="currentPlan.length==0">
                  <div style="text-align: center; color: #5e5e5e;" >
                    <h3>{{ 'employee_recharge.no_placeholder1' | translate }}</h3>
                    <p>{{ 'employee_recharge.no_placeholder2' | translate }}</p>
                  </div>
                </div>
  
                <!-- <div class="met_inc" >
                                      <i class="fa fa-user" aria-hidden="true"></i>
                                  </div> -->
              </div>
              <div style="background: #ffc107" (click)="renewEmployee()" >
                <div class="cdf_srd"  style="border-bottom: 1px solid lightgray;">
                  <div class="book_text" style="    padding: 20px 31px;
                  margin-bottom: 1px;
                  font-size: 20px;
                  font-weight: 500;
                  margin-bottom: 1px;">
                      <div class="entry_sec">
                          <mat-icon style="color:#222">navigate_next</mat-icon>
                      </div>
                      <p style="color:black">{{ 'employee_recharge.btn_text' | translate }}</p>
                  </div>
              </div>
              </div>            
            </a>
          </div>
        </div>
        <!-- <div class="col-sm-1"></div> -->
      </div>
    </div>
  </div>
  

